import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';

import { switchMap } from 'rxjs/operators/switchMap';
import {
  types as actions,
  errorReportSentAction,
} from '../../reducers/actions';
import { ZenossService } from '../../services';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.SEND_ERROR_REPORT),
    switchMap(action =>
      ZenossService.error(action.errorPayload).pipe(
        map(data => errorReportSentAction(data))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/report/sendError.js